import {Component, DestroyRef, inject, input, output, signal, WritableSignal} from '@angular/core';
import {ActionEvent} from '../../../../../../../core/interface/acton-event.interface';
import {ResultsService} from '../../../../../../../core/service/results/results.service';
import {BackButton} from '../../../../../../../../assets/shared/back-button/back-button';
import {ActivatedRoute, Router} from '@angular/router';
import {RadioButton} from 'primeng/radiobutton';
import {ReactiveFormsModule} from '@angular/forms';
import {CourseTests, Question} from '../../../../../../../core/interface/questions.interface';
import {dinamicQuestionModules} from '../../../../../../../data/questionData';
import {ModuleType, TestingResult} from '../../../../interface/testing.interface';
import {TestsService} from '../../../../../../../core/service/tests/tests.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'result-page',
  imports: [
    BackButton,
    ReactiveFormsModule
  ],
  templateUrl: './result-page.html',
  styleUrl: './result-page.scss',
})
export class ResultPage {
  private destroy = inject(DestroyRef);
  private testsService = inject(TestsService)
  private moduleData:WritableSignal<CourseTests[]> = signal(dinamicQuestionModules)
  private moduleTest:WritableSignal<string | null  | undefined> = signal('');
  private moduleType:WritableSignal<ModuleType | undefined> = signal(undefined);
  private coursesId: WritableSignal<string> = signal('');
  public questionResult: WritableSignal<TestingResult> = signal({ answer: 0, correctAnswersCount: 0 });
  public dinamicData:WritableSignal<Question[]> = signal([]);

  constructor(public  resultService: ResultsService, private router:Router , private activeRoute:ActivatedRoute ) {
    this.questionResult.set(this.resultService?.results)
    this.coursesId.set(this.activeRoute.snapshot.parent?.paramMap.get('coursesId')!);
  }

  ngOnInit(){
    if(!this.resultService.results)  {
      this.router.navigate([this.coursesId()])
    }else{
      this.initModule();
    }
  }

  private initModule(): void {
    this.moduleType.set(this.resultService?.results?.type);
    this.moduleTest.set(this.resultService?.results?.module);

    if (!this.moduleType() || !this.moduleTest() || !this.coursesId()) {
      this.router.navigate([this.coursesId()]);
      return;
    }
    const course = this.moduleData().find(c => c.courseId === Number(this.coursesId()));

    if (!course) {
      this.router.navigate([this.coursesId()]);
      return;
    }

    const foundItem = course.modules.find(m => m.moduleType === this.moduleType() && m.moduleNumber === this.moduleTest());

    if (!foundItem) {
      this.router.navigate([this.coursesId()]);
      return;
    }

    this.dinamicData.set(foundItem.questions!);
    if (this.resultService.results?.answer >=  this.resultService.results?.correctAnswersCount   && this.moduleType() === 'final') {
       this.sendResult();
    }
  }
  public restartTest(){
    this.router.navigate([this.coursesId() , 'test' , this.resultService?.results?.type,  this.resultService?.results?.module,])
  }

  public home(){
    this.router.navigate([this.coursesId()])
  }

  public sendResult(){
    this.testsService.completedTest(this.coursesId()!).pipe(takeUntilDestroyed(this.destroy)).subscribe({next:()=>{}})
  }

  public route(){
    return `${this.coursesId()}/test/${this.resultService?.results?.type}/${this.resultService?.results?.module}`
  }
}
